import Radio from './radio.vue';
import RadioGroup from './radio-group.vue';
import RadioButton from './radio-button.vue';

Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export default Radio;


// WEBPACK FOOTER //
// ./src/components/radio/index.js